import { FC, useEffect, useState } from 'react';

import { DangerZone, Information } from './layout';

// interface OverviewProps {}

const Overview: FC = (): JSX.Element => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(false);
    }, []);

    return (
        <>
            <Information />
            <DangerZone />
        </>
    );
};

export default Overview;
